import axios from "axios";
import { updateLoginStatus } from "../../Auth/authActions";
import { Partner_Service_URL } from "../../Url";

export const SubmitAllDocumentsActions = {
  SUBMIT_ALL_DOCUMENTS: "SUBMIT_ALL_DOCUMENTS",
  SUBMIT_ALL_DOCUMENTS_SUCCESS: "SUBMIT_ALL_DOCUMENTS_SUCCESS",
  SUBMIT_ALL_DOCUMENTS_ERROR: "SUBMIT_ALL_DOCUMENTS_ERROR",
  SUBMIT_ALL_DOCUMENTS_LOADING: "SUBMIT_ALL_DOCUMENTS_LOADING",
};

export const submitAllDocuments = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;
  dispatch(submitAllDocumentsLoading());
  return axios({
    method: "post",
    url: `${Partner_Service_URL}/submitDocumentsForApproval`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(submitAllDocumentsSuccess(response.data));
        dispatch(updateLoginStatus(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(submitAllDocumentsError(error));
        // dispatch(updateLoginStatus(error));
        throw error;
      }
    })
    .catch((error) => {
      dispatch(submitAllDocumentsError(error));
      // dispatch(updateLoginStatus(error));
      throw error;
    });
};

export function submitAllDocumentsError(error) {
  return {
    type: SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_ERROR,
    payload: error,
  };
}

export function submitAllDocumentsSuccess(props) {
  return {
    type: SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_SUCCESS,
    payload: props,
  };
}

export function submitAllDocumentsLoading() {
  return {
    type: SubmitAllDocumentsActions.SUBMIT_ALL_DOCUMENTS_LOADING,
  };
}
